import { render } from "./CadastroCarreta.vue?vue&type=template&id=32ccb01a"
import script from "./CadastroCarreta.vue?vue&type=script&lang=ts"
export * from "./CadastroCarreta.vue?vue&type=script&lang=ts"
script.render = render

export default script